import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileContract, faEnvelope, faPhone, faMapMarkerAlt, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

const Contract5373 = () => {
  return (
    <div id="GovernmentContracts">
      {/* Hero */}
      <div id="header" style={{ minHeight: "44vh" }}>
        <div className="hero-inner">
          <Link to="/government-contracts" className="contract-back-link">
            &larr; All Contracts
          </Link>
          <div className="hero-eyebrow">Texas DIR Contract</div>
          <h1 className="hero-headline">DIR-CPO-5373</h1>
          <p className="hero-sub">
            Data Storage, Data Communications &amp; Networking Equipment and Related Services
          </p>
        </div>
      </div>

      <section id="gov-contracts-section">
        <div className="container">
          <div className="contract-card">

            {/* Header */}
            <div className="contract-header">
              <div className="contract-logo">
                <img src="/img/dir_logo.png" alt="DIR Logo" />
              </div>
              <div className="contract-title">
                <h2>
                  <FontAwesomeIcon icon={faFileContract} className="contract-icon" />
                  DIR-CPO-5373
                </h2>
                <p className="contract-subtitle">Data Storage, Data Communications &amp; Networking Equipment</p>
              </div>
            </div>

            {/* Description */}
            <div className="contract-description">
              <p>
                Enteranet, LLC has been awarded a contract by the <strong>Texas Department of Information Resources (DIR)</strong> under
                Contract Number DIR-CPO-5373 for Data Storage, Data Communications &amp; Networking Equipment and Related Services.
              </p>
              <p>
                This contract enables eligible Texas state agencies, local governments, public education institutions, and other
                authorized entities to procure our products and services at negotiated, cost-effective rates.
              </p>
              <p>
                As a certified partner of <strong>Panduit, Commscope, Cisco, and Fortinet</strong>, Enteranet delivers enterprise-grade
                IT networking infrastructure, structured cabling, wireless technologies, VoIP solutions, cybersecurity, and professional
                services tailored to the public sector.
              </p>
            </div>

            {/* Services */}
            <div className="contract-services">
              <h3>Contract Services</h3>
              <div className="services-grid">
                <div className="service-item"><span className="service-checkmark">&#10003;</span><span>Networking and data communication hardware.</span></div>
                <div className="service-item"><span className="service-checkmark">&#10003;</span><span>Structured cabling systems and components.</span></div>
                <div className="service-item"><span className="service-checkmark">&#10003;</span><span>Installation, configuration, and support services.</span></div>
                <div className="service-item"><span className="service-checkmark">&#10003;</span><span>Wifi deployment and Access point installation.</span></div>
              </div>
            </div>

            {/* How to Order + Resources */}
            <div className="contract-footer">
              <div className="row">
                <div className="col-md-6">
                  <div className="info-box">
                    <h4>How to Order</h4>
                    <div className="contact-info">
                      <p className="contact-name"><strong>Robert Bernal</strong></p>
                      <p>
                        <FontAwesomeIcon icon={faEnvelope} className="info-icon" />
                        <a href="mailto:rbernal@enteranet.com">rbernal@enteranet.com</a>
                      </p>
                      <p>
                        <FontAwesomeIcon icon={faPhone} className="info-icon" />
                        <a href="tel:+14697900083">(469) 790-0083</a> |
                        <a href="tel:+19035303930"> (903) 530-3930</a>
                      </p>
                      <p>
                        <FontAwesomeIcon icon={faMapMarkerAlt} className="info-icon" />
                        715 Private Road 5939 Ste 4, Lavon, TX 75166
                      </p>
                      <p className="important-note">
                        <strong>Important:</strong> Reference Contract Number DIR-CPO-5373 on your purchase order
                      </p>
                    </div>
                  </div>

                  <div className="info-box">
                    <h4>Warranty</h4>
                    <p>Warranty coverage aligns with OEM manufacturer terms. Contact us for specifics during your quote or order.</p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="info-box">
                    <h4>Resources &amp; Links</h4>
                    <div className="resource-links">
                      <a href="https://dir.texas.gov/contracts/dir-cpo-5373" target="_blank" rel="noopener noreferrer" className="resource-link">
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                        View DIR Contract Page — DIR-CPO-5373
                      </a>
                      <a href="/Exhibit E Itemized Pricing list.xlsx" target="_blank" rel="noopener noreferrer" className="resource-link">
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                        Download Contract Pricing
                      </a>
                      <a href="https://dir.texas.gov/cooperative-contracts" target="_blank" rel="noopener noreferrer" className="resource-link">
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                        Learn About DIR Cooperative Contracts
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contract5373;
